import { getToken } from "../storage/authStorage";
import { API_BASE_URL } from "../../../config/api";
import type { TcsRecommendationDTO } from "../models/TaxDTOs";

/**
 * Fetch TCS recommendation by job ID.
 * GET /api/tax/tcs-recommendation?job_id={jobId}
 *
 * @param jobId - The job ID (invoice/bill processing job_id)
 * @returns The recommendation row or null if not found / on error (optional data)
 */
export async function fetchTcsRecommendationByJobId(
  jobId: string
): Promise<TcsRecommendationDTO | null> {
  const token = getToken();
  if (!token) {
    return null;
  }

  try {
    const url = `${API_BASE_URL}/api/tax/tcs-recommendation?job_id=${encodeURIComponent(jobId)}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 404) {
      return null;
    }

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.warn(
        "TCS recommendation fetch failed:",
        errorData.message || response.status
      );
      return null;
    }

    const json = await response.json();
    if (!json.success || !json.data) {
      return null;
    }

    return json.data as TcsRecommendationDTO;
  } catch (error) {
    console.warn(
      "TCS recommendation fetch error:",
      error instanceof Error ? error.message : error
    );
    return null;
  }
}
